import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import ServicesList from '../ServicesList'
import ServicesList2 from '../ServicesList2'
import ServicesTable from '../ServicesTable'
import './index.scss'

const ServicesCol = observer(() => {
  const content = ContentState.services
  if (!content) return <></>
  return (
    <section className="services-col">
      <ServicesTable />
      <ServicesList />
      <ServicesList2 />
    </section>
  )
})

export default ServicesCol
